const maintenanceRoutes = [
   {
      path: '/maintenance',
      name: 'maintenance-index',
      component: () => import('@/modules/maintenance/pages/Index.vue'),
   },
];

export default maintenanceRoutes;
